<template>
  <div>
    <vue-topprogress ref="loadingProgress"></vue-topprogress>

    <div class="animated fade-in" v-if="!loading">
      <h1 class="display-4 font-weight-lighter">{{ this.folder_name ? this.folder_name+' '  : 'Manage ' }} Library</h1>

      <div v-if="child_folders && child_folders.length" class="mt-3">
        <b-row>
          <b-col class="mb-4" cols="6" sm="6" md="4" xl="2" v-for="(child_folder) in child_folders">
            <b-button block squared variant="outline-dark" class="folder-tile d-flex"
                      :to="'/documents/'+child_folder.name.toString().toLowerCase().split(' ').join('-')"
            ><span class="m-auto text-center"><font-awesome-icon v-if="child_folder.icon" :icon="['fal', child_folder.icon]" class="mr-2"></font-awesome-icon>{{ child_folder.name }}</span></b-button>
          </b-col>
        </b-row>
        <hr class="mt-0 mb-4">
      </div>
      <div v-else class="mt-4"></div>

      <b-row v-if="documents && documents.length">
        <c-col v-for="(document) in documents" md="4" sm="12" class="mb-4">
          <div v-if="document.isImage" class="img-thumbnail p-4 text-center">
            <img :src="document.getFileUrl" class="w-m-100 h-m-100">
          </div>
          <div v-else-if="document.isVideo">
<!--            <video controls class="w-100">-->
<!--              <source :src="document.getFileUrl" :type="document.mime_type">-->
<!--            </video>-->
            <video-preview :document="document" class="border-bottom"></video-preview>
          </div>
          <div v-else-if="document.cover && document.cover.isImage" class="img-thumbnail p-4 text-center bg-gray-900">
            <img :src="document.cover.getFileUrl" class="w-m-100 h-m-100">
          </div>
          <template v-if="document.getLink">
            <document-signoff-modal :documentId="document.id"></document-signoff-modal>
            <a @click="openSignatureModal(document)" v-if="$route.path === '/documents/legal'" class="bg-dark p-4 d-block library-card">
              <h3 class="font-weight-bold m-0 p-0">
                <img src="img/brand/sf-logo-mini-white.svg" height="26" class="pr-2">
                <span class="pl-2">{{ document.name }}</span>
              </h3>
              <p v-if="document.description" class="m-0 p-0 pt-3">{{ document.description }}</p>
            </a>
            <a :href="document.getLink" :target="document.getLinkTarget" v-if="$route.path !== '/documents/legal'" class="bg-dark p-4 d-block library-card">
              <h3 class="font-weight-bold m-0 p-0">
                <img src="img/brand/sf-logo-mini-white.svg" height="26" class="pr-2">
                <span class="pl-2">{{ document.name }}</span>
              </h3>
              <p v-if="document.description" class="m-0 p-0 pt-3">{{ document.description }}</p>
            </a>
          </template>
          <div v-if="!document.getLink" class="bg-dark p-4 d-block library-card">
            <h3 class="font-weight-bold m-0 p-0">
              <img src="img/brand/sf-logo-mini-white.svg" height="26" class="pr-2">
              <span class="pl-2 font-2xl">{{ document.name }}</span>
            </h3>
            <p v-if="document.description" class="m-0 p-0 pt-3">{{ document.description }}</p>
          </div>
        </c-col>
      </b-row>
      <b-alert v-if="!documents || !documents.length" show>
        Current no documents.
      </b-alert>


    </div>

  </div>
</template>

<script>

import Document from "../../models/Document";
import DocumentFolder from "../../models/DocumentFolder";
import VideoPreview from "../../components/documents/VideoPreview";
import DocumentSignoffModal from '../../components/documents/DocumentSignoffModal.vue';

export default {
  name: "DocumentIndex",
  components: {VideoPreview, DocumentSignoffModal},
  props: ['folder'],
  data() {
    return {
      loading: true,
      folder_name: null,
      folder_id: null,
      document_folder: null,
      documents: null,
      permission_models: null,
      child_folders: null,
    };
  },
  methods: {
    openSignatureModal(document) {
      this.$bvModal.show(JSON.stringify(document.id))
    },
    populate() {
      this.document_folder = DocumentFolder.query().where('id', this.folder_id).with(['documents.cover']).first();
      this.documents = this.document_folder.documents;
      this.child_folders = DocumentFolder.query().where('parent_folder_id', this.folder_id).get();
    },
    fetch() {
      let filters = {};
      this.folder_name = (this.folder ? this.folder.split('-').join(' ').replace(/^(.)|\s+(.)/g, function ($1) {
        return $1.toUpperCase()
      }) : null);
      if(this.folder_name) {
        filters.name = this.folder_name;
      }
      let promises = [
        DocumentFolder.api().fetch(filters)
      ];
      return Promise.all(promises).then((response) => {
        let folders = [];
        response[0].entities.document_folders.forEach((folder) => {
          this.folder_id = folder.id;
          folders.push(folder.id);
        });
        return Promise.all([
          Document.api().fetch({document_folder_id: folders.join('|')}),
          DocumentFolder.api().fetch({parent_folder_id: folders.join('|')})
        ]);
      });
    },
    onFolderChange() {
      this.$refs.loadingProgress.start();
      this.loading = true;
      this.fetch().then(() => {
        this.populate();
        this.loading = false;
        this.$refs.loadingProgress.done();
      });
    }
  },
  watch: {
    folder: function () {
      this.onFolderChange();
    }
  },
  mounted() {
    this.onFolderChange();
  }
};
</script>